<template>
    <div class="ReportApproval">
        <Box :title="$route.params.ExistsAuditOrReport ? '医疗设备购置申请审批表' :'大型医疗设备购置可行性论证报告'">
            <div class="infoBox info">
                <p class="title">设备信息</p>
                <p class="items">申请单号： <span>{{$route.params.DH}}</span></p>
                <p class="items">设备名称： <span>{{dt.SBMC}}</span></p>
                <p class="items">规格型号： <span>{{dt.SBGG}}</span></p>
                <p class="items">申请数量： <span>{{parseInt(dt.CGSL)}}</span></p>
                <p class="items">预估单价： <span>{{Number(dt.CGDJ).toFixed(2)}}</span></p>
                <p class="items">总&nbsp;&nbsp;金&nbsp;&nbsp;额：<span>{{Number(dt.CGJE).toFixed(2)}}</span></p>
            </div>
            <div class="infoBox box2">
                <p class="title">设备购置申请</p>
                <Field title="推荐品牌" placeholder="请输入" :text="params.KSTJPPY" @onMessage="value => params.KSTJPPY = value" />
                <Field title="推荐品牌" placeholder="请输入" :text="params.KSTJPPE" @onMessage="value => params.KSTJPPE = value" />
                <Field title="推荐品牌" placeholder="请输入" :text="params.KSTJPPS" @onMessage="value => params.KSTJPPS = value" />
                <p class="itemTitle">设备购置目的</p>
                <div class="checkBox">
                    <van-checkbox-group v-model="GZMD">
                        <van-checkbox v-for="(item, index) in GZMDArr" :name="item.id" :key="item.id" checked-color="#4fa69e">{{item.name}}</van-checkbox>
                    </van-checkbox-group>
                </div>
                <Field title="申购理由" placeholder="请输入" :text="$route.params.ExistsAuditOrReport?params.SQYY:params.SGLY"
                    @onMessage="value =>$route.params.ExistsAuditOrReport?params.SQYY=value:params.SGLY = value" type="textarea" />
            </div>
            <div v-if="!$route.params.ExistsAuditOrReport">
                <div class="infoBox">
                    <p class="title">可行性分析</p>
                    <textarea placeholder="请输入可行性评价，例如(诊疗技术、人员资质、场地 条件、收费标准、安全性等)" rows="4" cols="5" v-model="params.KXXPJ" />
                    </div>
                <div class="infoBox">
                    <p class="title">技术先进性评价</p>
                    <textarea placeholder="请输入技术先进性评价，例如(技术性本地区不落后，技术适宜，易掌握，应用技术功能明确)"
                    rows="4" cols="5" v-model="params.JSXJXPJ"/>
                </div>
                <div class="infoBox">
                    <p class="title">国内外同类设备性能价格对比</p>
                    <textarea placeholder="请输入国内外同类型设备性能价格对比，例如(关键性能、关键指标、适用范围、使用禁忌、安全性、价格等比较)"
                    rows="4" cols="5" v-model="params.TLXSHXN"/>
                </div>
                <div class="infoBox">
                    <p class="title">科室同类型设备</p>
                    <textarea placeholder="请输入科室现有同类型号、数量、性能、使用情况"
                    rows="4" cols="5" v-model="params.KSXYTLSBXH"/>
                </div>
            </div>
            <div class="infoBox box3">
                <p class="title">经济效益</p>

                <Field title="设备属性" type="teb"  :tabSelected="params.SBSX"
                 :data="[{id:'检测',name:'检测'},{id:'治疗',name:'治疗'},{id:'辅助',name:'辅助'}]"
                 @onMessage="value => params.SBSX = value.name"/>

                <Field title="有无收费标准" type="teb"
                 :tabSelected="params.YWSFBZ" :data="[{id:'有',name:'有'},{id:'无',name:'无'}]"
                 @onMessage="value => params.YWSFBZ = value.name"/>

                <Field title="收费是否进医保" type="teb" :tabSelected="params.SFSFJYB"
                :data="[{id:'是',name:'是'},{id:'否',name:'否'}]"
                 @onMessage="value => params.SFSFJYB = value.name"/>

                <Field title="预估单价" placeholder="请输入" :text="params.SBYJDJ" @onMessage="value => params.SBYJDJ = value"/>
                <Field title="月收入(元)" placeholder="请输入预计月收入" :text="params.YSR" @onMessage="value => params.YSR = value"/>
                <Field title="用途" placeholder="请输入用途" :text="params.SBYT" @onMessage="value => params.SBYT = value"/>
                <Field title="月折旧" placeholder="请输入月折旧" :text="params.SBYZJ" @onMessage="value => params.SBYZJ = value"/>
                <Field title="收费标准" placeholder="请输入收费标准" :text="params.SFBZ" @onMessage="value => params.SFBZ = value"/>
                <Field title="治疗时间" placeholder="请输入治疗时间" :text="params.ZLSJ" @onMessage="value => params.ZLSJ = value"/>
                <Field title="投资回收期(月)" placeholder="请输入预计回收期" :text="params.TZHSQ" @onMessage="value => params.TZHSQ = value"/>
                <Field title="社会效益" placeholder="请输入社会效益" type="textarea" :text="params.SHXY" @onMessage="value => params.SHXY = value"/>
            </div>
        </Box>
        <Footer v-if="!($route.params.SHZT=='1'||$route.params.SHZT=='2')" button="保存" @change="save"/>
    </div>
</template>

<script>
    import Box from '../../components/commonBox/commonBox'
    import Field from '../../components/field/field'
    import Footer from '../../components/footer/footer'
    import {CheckboxGroup, Checkbox} from 'vant'
    export default {
        name: 'ReportApproval',
        components: {
            Box,
            Footer,
            Field,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup
        },
        data() {
            return {
                dt:this.$route.params.Report,
                GZMDArr: [{id:'YWTZXY',name:'业务拓展需要'},
                {id:'XJSKFXY',name:'新技术开发需要'},
                {id:'JCYLAQXY',name:'基础医疗安全需要'},
                {id:'JSGXXY',name:'技术更新需要'},
                {id:'JJXYXY',name:'经济效益需要'},
                {id:'XKJSXY',name:'学科建设需要'},
                {id:'KYJXXY',name:'科研教学需要'},
                {id:'ZCXXM',name:'政策性项目'},
                {id:'GZMDQT',name:'其它'}
                ],
                params:{
                    LRR:this.$UserInfo.UserId,
                    // SQKS:this.
                    SBSX:'检测',
                    YWSFBZ:'有',
                    SFSFJYB:'是'
                },
                GZMD: [],//购置目的
            }
        },
        mounted(){
         //获取购置申请表
         this.loadDefault();
        },
        methods: {
            save() {
                //整理购置目的数据
                for(let i=0;i<this.GZMD.length;i++){
                    this.params[this.GZMD[i]]=1;
                }
                this.params.DH=this.$route.params.DH;
                this.params.SBMC=this.$route.params.Report.SBMC;
                this.params.SBMCBH=this.$route.params.Report.SBMCBH;
                this.$post(this.$route.params.ExistsAuditOrReport?'api/SBSG/EditGZSQSP':'api/SBSG/EditGZLZ',{mdoel:this.params}).then(result=>{
                    if(result.Status){
                        this.$Toast({
                            message:'保存成功!',
                            duration:1500,
                            onClose:()=>{
                                this.$router.back();
                            }
                        });
                    }else{
                        this.$Toast(result.Msg);
                    }
                })
            },loadDefault(){
                this.$get(this.$route.params.ExistsAuditOrReport?'api/SBSG/GetGZSQSPInfo':'api/SBSG/GetGZLZInfo',{
                    DH: this.$route.params.DH,
                    SBMC:this.dt.SBMC,
                    SBBH:this.dt.SBMCBH
                }).then(result=>{
                    if(!!result.sbxy[0]){
                        this.params=result.sbxy[0];
                    }
                    if(!!result.dt[0]){
                        this.params.SQKS=result.dt[0].KSID;
                    }
                    this.GZMDArr.forEach(x=>{
                        if(this.params[x.id]==='1'){
                            this.GZMD.push(x.id);
                        }
                    })
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .ReportApproval{
        padding-bottom: 112px;
    }
    .info{
        .items{
            margin-bottom: 25px;
            font-size: 28px;
            color: #999;
            span{
                color: #333;
            }
            &:last-child{
                margin-bottom: 0;
            }
        }
    }
    .box2,.box3{
        .title{
            margin-bottom: 0;
        }
    }
    .itemTitle{
        font-size: 30px;
        color: $TEXT-DARK-COLOR;
        margin: 38px 0;
    }
    .checkBox{
        &>div>div{
            height: 90px;
            border-bottom: 2px solid #f3f3f3;
            font-size: 28px;
            color: $TEXT-DARK-COLOR;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/reportApproval/reportApproval.vue